// extracted by mini-css-extract-plugin
module.exports = {"genderStatisticsContainer":"genderStatistics_genderStatisticsContainer__nFtsk"};